import Alpine from "alpinejs";
import { subscribe } from "../../_api/klaviyo";

export const alpineDataKlaviyoNewsletter = () =>
  Alpine.data("klaviyoNewsletter", () => ({
    email: "",
    companyId: KLAVIYO_COMPANY_ID,
    listId: KLAVIYO_LIST_ID,
    isFocused: false,
    error: "",
    loading: false,
    success: false,
    handleKeydown(event) {
      if (event.key === "Enter") {
        this.submit();
      }
    },
    checkIsValidEmail() {
      const emailInput = this.$refs.email;
      const isValid = emailInput.checkValidity();
      return isValid;
    },
    async submit() {
      this.error = "";
      this.loading = true;

      if (!this.checkIsValidEmail()) {
        this.error = "Invalid email address";
        this.loading = false;
        return;
      }

      try {
        const response = await subscribe({
          email: this.email,
          listId: this.listId,
          companyId: this.companyId,
        });

        this.loading = false;
        if (response.error) {
          this.error = response.error;
          this.success = false;
        } else {
          this.email = "";
          this.success = true;
        }
      } catch (error) {
        this.error = error.message;
        this.loading = false;
        this.success = false;
      }
    },
  }));
